import React, { FC } from 'react';
import GenericNotification, {
  IGenericNotification,
} from '../GenericNotification';
import { ErrorIcon, Icon } from 'src/components/Icons';
import { t } from 'i18next';
import { useUrlParameterCheck } from 'src/utils/useUrlParameterCheck';

type TErrorNotification = Pick<
  IGenericNotification,
  Exclude<keyof IGenericNotification, 'type'>
>;

const ErrorNotification: FC<TErrorNotification> = props => {
  const { text, ...notificationProps } = props;
  const isFromMvpApp = useUrlParameterCheck('/app');

  return (
    <GenericNotification
      type={'Error'}
      Icon={
        isFromMvpApp ? (
          <ErrorIcon />
        ) : (
          <Icon color="white" type="delete" aria-label={t('Close')} />
        )
      }
      text={text}
      {...notificationProps}
    />
  );
};

export default ErrorNotification;
